export enum BillingModeEnum {
  Individual = "individual",
  Collective = "collective"
}
